import {
  IMarketplaceCartLine,
  IMarketplaceCategory,
  IMarketplaceFilters,
  IMarketplaceProductDetails,
} from '../../types/marketplace';
import {
  ActionsEnum,
  IError,
  IMarketplaceCatalogRequestPayload,
  IMarketplaceCatalogSuccessPayload,
  IMarketplaceHydrateItemFailurePayload,
  IMarketplaceHydrateItemsPayload,
  IMarketplaceHydrateItemSuccessPayload,
} from '../../types/store';

export const marketplaceCatalogRequestAction = (payload: IMarketplaceCatalogRequestPayload = {}) => ({
  type: ActionsEnum.MarketplaceCatalogRequest,
  payload,
});

export const marketplaceCatalogSuccessAction = (payload: IMarketplaceCatalogSuccessPayload) => ({
  type: ActionsEnum.MarketplaceCatalogSuccess,
  payload,
});

export const marketplaceCatalogFailureAction = (payload: IError) => ({
  type: ActionsEnum.MarketplaceCatalogFailure,
  payload,
});

export const marketplaceCategoriesSuccessAction = (payload: IMarketplaceCategory[]) => ({
  type: ActionsEnum.MarketplaceCategoriesSuccess,
  payload,
});

export const marketplaceSetFiltersAction = (payload: Partial<IMarketplaceFilters>) => ({
  type: ActionsEnum.MarketplaceSetFilters,
  payload,
});

export const marketplaceProductRequestAction = (productId: string) => ({
  type: ActionsEnum.MarketplaceProductRequest,
  payload: productId,
});

export const marketplaceProductSuccessAction = (payload: IMarketplaceProductDetails) => ({
  type: ActionsEnum.MarketplaceProductSuccess,
  payload,
});

export const marketplaceProductFailureAction = (payload: IError) => ({
  type: ActionsEnum.MarketplaceProductFailure,
  payload,
});

// Add straight from a catalog card: the saga decides once details resolve whether the product
// goes to the cart or the sidebar.
export const marketplaceAddDirectRequestAction = (productId: string) => ({
  type: ActionsEnum.MarketplaceAddDirectRequest,
  payload: productId,
});

export const marketplaceOpenDetailsAction = (productId: string) => ({
  type: ActionsEnum.MarketplaceOpenDetails,
  payload: productId,
});

export const marketplaceCloseDetailsAction = () => ({
  type: ActionsEnum.MarketplaceCloseDetails,
});

export const marketplaceSetCartOpenAction = (isOpen: boolean) => ({
  type: ActionsEnum.MarketplaceSetCartOpen,
  payload: isOpen,
});

export const marketplaceSwapStartAction = (payload: IMarketplaceCartLine) => ({
  type: ActionsEnum.MarketplaceSwapStart,
  payload,
});

export const marketplaceSwapCancelAction = () => ({
  type: ActionsEnum.MarketplaceSwapCancel,
});

export const marketplaceAddToCartAction = (payload: IMarketplaceCartLine) => ({
  type: ActionsEnum.MarketplaceAddToCart,
  payload,
});

export const marketplaceRemoveFromCartAction = (variantId: string) => ({
  type: ActionsEnum.MarketplaceRemoveFromCart,
  payload: variantId,
});

export const marketplaceClearCartAction = () => ({ type: ActionsEnum.MarketplaceClearCart });

export const marketplaceReplaceCartAction = (payload: IMarketplaceCartLine) => ({
  type: ActionsEnum.MarketplaceReplaceCart,
  payload,
});

export const marketplaceRestoreCartAction = () => ({ type: ActionsEnum.MarketplaceRestoreCart });

export const marketplaceDropReplacedCartAction = () => ({ type: ActionsEnum.MarketplaceDropReplacedCart });

export const marketplaceSetSupplierFilterAction = (isOn: boolean) => ({
  type: ActionsEnum.MarketplaceSetSupplierFilter,
  payload: isOn,
});

export const marketplaceSetCacheValueAction = (cacheValue: string) => ({
  type: ActionsEnum.MarketplaceSetCacheValue,
  payload: cacheValue,
});

// Stamps every id as loading in the reducer and starts the fetch waves in the saga.
export const marketplaceHydrateItemsRequestAction = (payload: IMarketplaceHydrateItemsPayload) => ({
  type: ActionsEnum.MarketplaceHydrateItemsRequest,
  payload,
});

export const marketplaceHydrateItemSuccessAction = (payload: IMarketplaceHydrateItemSuccessPayload) => ({
  type: ActionsEnum.MarketplaceHydrateItemSuccess,
  payload,
});

export const marketplaceHydrateItemFailureAction = (payload: IMarketplaceHydrateItemFailurePayload) => ({
  type: ActionsEnum.MarketplaceHydrateItemFailure,
  payload,
});
